import React from 'react';
import Reveal from '../ui/Reveal';
import Button from '../ui/Button';
import './DualCTA.css';

const scrollToContact = () => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });

const DualCTA = () => {
  return (
    <section className="dualcta tra-section">
      <div className="tra-container">
        <div className="dualcta__grid">
          <Reveal className="dualcta__panel dualcta__panel--brands">
            <span className="dualcta__tag">For Brands</span>
            <h3 className="dualcta__title">Ready to reach millions of gamers?</h3>
            <p className="dualcta__desc">
              Launch authentic creator campaigns that actually convert. Let's build a strategy
              that hits your numbers.
            </p>
            <Button onClick={scrollToContact} variant="primary" size="lg" arrow>
              Work With Us
            </Button>
          </Reveal>

          <Reveal className="dualcta__panel dualcta__panel--creators" delay={0.1}>
            <span className="dualcta__tag">For Creators</span>
            <h3 className="dualcta__title">Want to grow and monetize your channel?</h3>
            <p className="dualcta__desc">
              Join a roster that handles the business side — sponsorships, editing, strategy —
              so you can focus on creating.
            </p>
            <Button onClick={scrollToContact} variant="secondary" size="lg" arrow>
              Join Our Roster
            </Button>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default DualCTA;
